import React from "react";
import {AnyAction} from "redux";

import {Button, Stack, Tab, Tabs} from "@mui/material";

import {ReportDto} from "../../../../app/client/app/entity/Project";
import {ProjectReportListTab} from "./ProjectReportListTab";
import {Spacer} from "../../../../qdep/components/app/util/spacer/Spacer";
import {addReport} from "../data/action";
import {TabPanel} from "../../../../qdep/components/app/util/tab-panel/TabPanel";


interface EditorTabsProps {
    projectName: string
    reports: ReportDto[]

    dispatch: React.Dispatch<AnyAction>
}

const EditorTabs = (props: EditorTabsProps) => {
    const [tabIndex, setTabIndex] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    return <>
        <Stack direction={"row"} alignItems={"center"}>
            <Tabs value={tabIndex} onChange={handleChange} indicatorColor={"secondary"} textColor={"secondary"}>
                <Tab sx={{fontSize: "16px"}} label={"Reports"}/>
            </Tabs>
            <Spacer/>
            { tabIndex === 0 &&
                <div>
                    <Button
                        variant={"outlined"}
                        onClick={() => props.dispatch(addReport())}
                    >
                        Add Report
                    </Button>
                </div>
            }
        </Stack>
        <div style={{padding: "15px 0"}}>
            <TabPanel index={0} value={tabIndex}>
                <ProjectReportListTab dispatch={props.dispatch} reports={props.reports} projectName={props.projectName}/>
            </TabPanel>
        </div>
    </>
}

export {EditorTabs}
